const FLIP_STATE_KEY = 'pend-jessie-jumble-flip-state';

/**
 * @returns {{ collectionName: string, flippedCardNames: string[] } | null}
 */
export function loadPersistedFlipState() {
    try {
        const raw = window.localStorage.getItem(FLIP_STATE_KEY);
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || typeof data.collectionName !== 'string') return null;
        const flippedCardNames = Array.isArray(data.flippedCardNames)
            ? data.flippedCardNames
            : [];
        return { collectionName: data.collectionName, flippedCardNames };
    } catch {
        return null;
    }
}

/**
 * @param {{ collectionName: string, flippedCardNames: string[] }} state
 */
export function savePersistedFlipState(state) {
    try {
        window.localStorage.setItem(FLIP_STATE_KEY, JSON.stringify(state));
    } catch {
        // ignore storage errors
    }
}
